<div *ngIf="outerSearchMode" class="outer-search-wrapper">
	<div class="outer-search-title">{{outerSearchTitle | cpTitleTranslate}}</div>
	<cp-search-box-widget #searchBox
						  class="no-bgc"
						  [searchString]="searchText"
						  [debounce]="250"
						  [enableClearButton]="true"
						  [focusOnInit]="false"
						  (onClear)="onSearchClear()">
	</cp-search-box-widget>
</div>

<cp-layout-box [ngClass]="{'short' : outerSearchMode}">
	<span cp-layout-box-header-title (click)="toggleCollapse();" class="list-title" [ngClass]="{'clickable' : collapsible}">
		<i *ngIf="collapsible && collapseIcon" class="{{collapseIcon}} collapse-icon cp-icon-color-1"></i>
		<span>{{translatedTitle ? translatedTitle : ((title ? title : 'Studies') | cpTitleTranslate)}}</span>
	</span>

	<div cp-layout-box-header-content>
		<div class="header-actions">
			<cp-search-box-widget *ngIf="!outerSearchMode"
								  #searchBox
								  class="no-bgc"
								  [searchString]="searchText"
								  [enableClearButton]="true"
								  [debounce]="250"
								  [focusOnInit]="false"
								  (onClear)="onSearchClear()">
			</cp-search-box-widget>
			<cp-button-widget-custom class="textButton5" *ngIf="showAllButton" [titlePlain]="'AllStudies'" (onClick)="toggleItemsList()"></cp-button-widget-custom>
			<cp-button-widget-custom class="textButton5" *ngIf="showAddAll && !iconsMode" [titlePlain]="'AddAll'" (onClick)="addAll()"></cp-button-widget-custom>
			<cp-button-widget-custom class="tertiary-button with-icon" *ngIf="showAddAll && iconsMode" [iconClass]="'cp-icon-add_all'" [titleToTranslate]="'AddAll'" (onClick)="addAll();"></cp-button-widget-custom>
			<cp-button-widget-custom class="textButton5" *ngIf="showRemoveAll && !iconsMode" [titlePlain]="'ClearAll'" (onClick)="removeAll()"></cp-button-widget-custom>
			<cp-button-widget-custom class="tertiary-button with-icon" *ngIf="showRemoveAll && iconsMode" [iconClass]="'cp-icon-remove-all'" [titleToTranslate]="'RemoveAll'" (onClick)="removeAll();"></cp-button-widget-custom>
		</div>
	</div>

	<div cp-layout-box-content class="no-search-results-message" *ngIf="searchText !== '' && itemsListBound.length === 0">{{'ItemsSearchNoResults' | cpMessageTranslate}}</div>

	<cp-vertical-list-scrollable
		cp-layout-box-content
		*ngIf="itemsListBound.length > 0"
		[items]="itemsListBound"
		[field]="'description'"
		[navigatable]="navigatable"
		(itemClick)="itemClickHandler($event)"
		(itemDoubleClick)="itemDoubleClickHandler($event)">

		<ng-template
			cpVerticalListScrollableItem
			let-dataItem="dataItem">
			<cp-list-selection-list-item
				[item]="dataItem.originalData"
				[searchTerms]="searchTerms"
				[alwaysShowRemove]="alwaysShowRemove"
				(addItem)="addItemHandler(dataItem.originalData)"
				(removeItem)="removeItemHandler(dataItem.originalData)">
			</cp-list-selection-list-item>
		</ng-template>

	</cp-vertical-list-scrollable>

</cp-layout-box>

<div class="bottom-select-actions" *ngIf="showAddAllOnBottom || showRemoveAllOnBottom">
	<cp-button-widget-custom class="tertiary-button with-icon"
							 *ngIf="showAddAllOnBottom"
							 [iconClass]="'cp-icon-add_all'"
							 [titleToTranslate]="'AddAll'"
							 [isDisabled]="itemsListBound.length === 0"
							 (onClick)="addAll();">
	</cp-button-widget-custom>
	<cp-button-widget-custom class="tertiary-button with-icon"
							 *ngIf="showRemoveAllOnBottom"
							 [iconClass]="'cp-icon-remove-all'"
							 [titleToTranslate]="'RemoveAll'"
							 [isDisabled]="itemsListBound.length === 0"
							 (onClick)="removeAll();">
	</cp-button-widget-custom>
</div>

